<template>
  <b-modal ref="modal-conf-excluir" :id="resolvedModalId" size="lg" title="Confirmação" hide-footer >
        <div class="container-fluid">
          <b-row class="my-1">
            <div class="col-md-12">
              <slot name="texto"></slot>              
            </div>
          </b-row>          
          <b-row class="my-1">
            <div class="col-md-12">
              <button
                size="sm"
                style="margin-left: 4px"
                class="btn btn-danger btn-fill float-right"
                @click="nao"
              >
                Não
              </button>
              <button
                size="sm"
                class="btn btn-success btn-fill float-right"
                @click="sim"
              >
                Sim
              </button>
            </div>
          </b-row>
        </div>
      </b-modal>      
</template>

<script>

let seq = 0;

export default {    
    props: ['modalId','id'],
    data() {
        return {
        
        }
    },
    methods: {
        sim() {
            this.hide()
            this.$emit('respondeu', 'S')            
            this.$emit('sim', this.id)
        },
        nao() {
            this.hide()
            this.$emit('respondeu', 'N')
            this.$emit('nao', this.id)
        },
        show() {
            this.$bvModal.show(this.resolvedModalId)
        },
        hide() {
            this.$bvModal.hide(this.resolvedModalId)
        } 
    },
    computed: {
      // fallback único se o pai não passar modal-id
      resolvedModalId() {
        return this.modalId || `modal-confirma-${++seq}`;
      }
    }
}
</script>

<style>

</style>